import {
  Box,
  Button,
  Container,
  Flex,
  Heading,
  Text,
} from '@chakra-ui/react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Link, graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import FlareGroup1 from '../../assets/shapes/shape-group-1.svg';
import { HalfByHalfSection } from '../_index';
import Flare3 from '../../assets/shapes/flare-3.svg';

const ContentBlock = () => (
  <>
    <Heading
      as="h4"
      size="2xl"
      mb={4}
    >
      <span className="highlight">Clear and Upfront Offer</span>
    </Heading>
    <Text fontSize="2xl">
      You don’t need to imagine knowing the when and how much your
      home will be sold for. We make that a reality as you get the
      exact amount you have agreed to! No fees, no surprises, and
      leaving nothing to chance!
    </Text>
    <Link to="/get-offer">
      <Button
        mt={10}
        variant="btnCTA"
        size="lg"
        isLoading={false}
        type="submit"
      >
        Get A Clear Offer!
      </Button>
    </Link>
  </>
);

const FlareBlock = ({ img }) => (
  <Box
    zIndex="0"
    height={{ base: '15rem', md: '25rem' }}
    display={{ base: 'none', lg: 'block' }}
  >
    <Box
      transform={{ base: 'scale(.7)', md: 'scale(1)' }}
      mt={6}
      className="width-500 "
      display={{ sm: 'block', md: 'block' }}
      position="relative"
    >
      <Box
        position="absolute"
        top={{ base: '0%', md: '-20%' }}
      >
        <FlareGroup1 className="flip-y width-400 height-400 width-md-500 height-md-500" />
      </Box>

      {img && (
        <Box
          position="absolute"
          className="width-300"
        >
          <GatsbyImage
            alt="100% guaranteed"
            image={img}
          />
        </Box>
      )}
    </Box>
  </Box>
);

const UpfrontOfferBlock = () => {
  const { flareImage } = useStaticQuery(query);
  const image = getImage(flareImage);

  return (
    <Box
      backgroundColor="gray.100"
      py={20}
    >
      <Container maxW="container.xl">
        <HalfByHalfSection
          left={<ContentBlock />}
          right={<FlareBlock img={image} />}
        />
      </Container>
    </Box>
  );
};

export const query = graphql`
  query {
    flareImage: file(
      relativePath: { eq: "satisfaction-guaranteed.png" }
    ) {
      childImageSharp {
        gatsbyImageData(width: 600, placeholder: BLURRED)
      }
    }
  }
`;

export default UpfrontOfferBlock;
